<!-- <form>
<input type="file" multiple (input)="handleFileInput($event)" />
</form> -->

<file-pond
  #myPond
  [options]="pondOptions"
  (onaddfile)="pondHandleAddFile($event)"
  >
</file-pond>

<div>
  @for (session of uploadSessions$ | async; track session) {
    <div>
      <black-file-upload
        [uploadSession]="session"
      ></black-file-upload>
    </div>
  }
</div>
